import tokens from '@skodaflow/web-tokens/src/tokens.json';

// The style for elevation from tokens
const getElevation = (elevationName: string): string => {
  const elevation = tokens['flow-effects'].find((el) => el.name === elevationName);
  if (elevation) {
    const { color, offset, radius, spread } = elevation.style;
    return `0px ${offset.y}px ${radius}px ${spread}px ${color}`;
  }
  return 'none';
};

// Flow elevations using the utility function
export const flowElevations = {
  xs: getElevation('XS'),
  s: getElevation('S'),
  m: getElevation('M'),
  l: getElevation('L'),
  xl: getElevation('XL'),
};
